import React from "react";
import { BrowserRouter, Routes } from "react-router-dom";

import Toast from "./components/Alerts";
import { useToastGlobal } from "./stores/useToastGlobal";

import { appRoutes } from "./routes";

function App() {
    const toastConfig = useToastGlobal();

    return (
        <>
            {/* global Toast */}
            <Toast
                content={toastConfig.content}
                visible={toastConfig.visible}
                level={toastConfig.level}
                actions={toastConfig.actions}
                auto_hide_timeout={toastConfig.auto_hide_timeout}
                dismissible={toastConfig.dismissible}
                onStatusChange={toastConfig.onChangeStatus}
                key="global_toast"
            />
            <BrowserRouter>
                <Routes>
                    {appRoutes.map((route, index) => {
                        return React.cloneElement(route, {
                            key: "route_" + index,
                        });
                    })}
                </Routes>
            </BrowserRouter>
        </>
    );
}

export default App;
